import React, {useState} from 'react';
import './App.scss';
import Nav from "./components/Nav";
import Welcome from "./components/Welcome";
import Stories from "./components/Stories";
import Socials from "./components/Socials";
import Calender from "./components/Calender";
import FAQ from "./components/FAQ";
import NariComments from "./components/Nari-Comments";
import Events from "./components/Events";

function App() {
    const [showingApp, setShowingApp] = useState('home');

    return (
        <div className="App">
            {showingApp === 'home' ?
                <div className={'home'}>
                    <header className="App-header">
                        <Socials/>
                    </header>
                    <Nav></Nav>
                    <main className="App-main u-container">
                        <Welcome/>
                        <Events/>
                        <Stories/>
                        <Calender/>
                        <FAQ setShowingApp={setShowingApp} />
                        <div className='foot'> </div>
                    </main>
                </div>:
                ''
            }
            {showingApp === 'nari-comment' ?
                <div className={'nari-comment'}>
                    <NariComments/>
                </div>:
                ''
            }
        </div>
    );
}

export default App;
